export const removeEmptyParagraphs = (html: string) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  const paragraphs = doc.querySelectorAll("p");

  for (const p of paragraphs) {
    const content = p.textContent?.trim();
    if (!content) {
      p.remove();
    }
  }

  return doc.body.innerHTML;
};

export const insertTextAtBeginningOfHtml = (textToAdd: string, html: string) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(removeEmptyParagraphs(html), "text/html");

  const walker = document.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT, {
    acceptNode(node) {
      return node.textContent?.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    },
  });

  const firstTextNode = walker.nextNode();
  if (firstTextNode) {
    firstTextNode.textContent = `${textToAdd} ${firstTextNode.textContent}`;
  }

  return doc.body.innerHTML;
};
